import { Offcanvas, Modal } from 'bootstrap'
import feather from 'feather-icons'
import LazyLoad from 'vanilla-lazyload'
export default () => {
	$('video, img').addClass('lazy')
	new LazyLoad()
	feather.replace()
	$('#hamburger').click(function (){
		$(this).toggleClass('active')
		$('#slide-topmenu').toggle()
	})
	
	// console.log($('.woocommerce input.qty').length)
	// $('.woocommerce input.qty').on('change keyup paste click set', function (){
	// 	console.log('qweqwewqewqeq')
	// })
		// console.log('sadasdasdasd')
		// $( document.body ).trigger('update_checkout')
	// })
	let timeout
	$('.grp-quantity-input .btn-minus, .grp-quantity-input .btn-plus').click(function (e){
		e.preventDefault()
		const role = $(this).attr('role')
		const eleInputQuantity = $('.qty', $(this).parent())
		let quantity = eleInputQuantity.val()
		if(quantity <= 0 && role === 'minus') return
		if(role==='minus'){
			quantity = parseInt(quantity) - 1
			eleInputQuantity.val(quantity)
		}
		else{
			quantity = parseInt(quantity) + 1
			eleInputQuantity.val(quantity)
		}
		
		if($('body').hasClass('cart-vs')){
			$('[name="update_cart"]').prop('disabled', false)
			if ( timeout !== undefined ) {
				clearTimeout( timeout )
			}
			timeout = setTimeout(function() {
				$('[name="update_cart"]').trigger('click')
			}, 500 )
		}
	})
	
	if($('#offcanvasRight').length){
		new Offcanvas('#offcanvasRight')
	}
	
	$('.vnav-top_isearch svg').click(function (){
		$('#mini-search-header').toggleClass('active')
	})
	
	$('body').click(function (e){
		if( $(e.target).closest('.vnav-top_isearch').length != 0) return
		$('#mini-search-header').removeClass('active')
	})
	
	$(document.body).on(
		'added_to_cart',
		function (event, fragments, cartHash, $button) {
			// Lấy tên sản phẩm
			const label =
				$($button[0]).attr('aria-label') || $('.product_title').html()
			
			// const productId = $($button[0]).data('product_id')
			
			// $('.add_to_cart_button[data-product_id="' + productId + '"]').prop(
			// 	'disabled',
			// 	false
			// )
			// Cập nhật lại số lượng trong giỏ hàng và tổng giá
			// helper.updateCartCount()
			// Popup Thông báo
			if (label) {
				// swal('"' + label + '" was added to shopping cart.', '', 'success')
				// let span = document.createElement('span')
				// span.innerHTML = '<a href="/cart">View Cart</a>'
				// swal({
				// 	icon: 'success',
				// 	title: '"' + label + '" was added to shopping cart.',
				// 	content: span,
				// })
			}
		}
	)
	const setCookie = (cname, cvalue, extime) => {
		const d = new Date()
		d.setTime(d.getTime() + (extime*1000))
		let expires = 'expires=' + d.toUTCString()
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
	}

	const getCookie = (cname) => {
		let name = cname + '='
		let decodedCookie = decodeURIComponent(document.cookie)
		let ca = decodedCookie.split(';')
		for(let i = 0; i <ca.length; i++) {
			let c = ca[i]
			while (c.charAt(0) === ' ') {
				c = c.substring(1)
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length)
			}
		}
		return ''
	}

	$(document).ready(function (){
		if ($('#backtotop').length) {
			const scrollTrigger = 200,
				backToTop = function() {
					const scrollTop = $(window).scrollTop()
					if (scrollTop > scrollTrigger) {
						$('#backtotop').addClass('show')
					} else {
						$('#backtotop').removeClass('show')
					}
				}
			backToTop()
			$(window).on('scroll', function() {
				backToTop()
			})
			$('#backtotop').on('click', function(e) {
				e.preventDefault()
				$('html,body').animate({
					scrollTop: 0
				}, 700)
			})
		}

		if($('#glpopup').length){
			const glPopup = new Modal('#glpopup', {
				keyboard: false
			})
			const cookieGlPopup = getCookie('glpopup')
			if(cookieGlPopup !== '1'){
				glPopup.toggle()
				document.addEventListener( 'wpcf7mailsent', function() {
					//Your code here
					glPopup.hide()
				}, false )
			}

			const glPopupEl = document.getElementById('glpopup')
			const timeRepeat = $('#glpopup').data('repeat')
			const closeWhenClick = $('#glpopup').data('click-close')
			console.log(closeWhenClick, typeof closeWhenClick)
			if (closeWhenClick === 1) {
				$('#glpopup').click(function (){
					setTimeout(function (){
						glPopup.hide()
					}, 500)
				})
			}
			glPopupEl.addEventListener('hidden.bs.modal', () => {
				setCookie('glpopup', 1, timeRepeat)
			})
		}

	})
	
}